import CMSPage from 'client/pages/CMSPage/CMSPage';
import { CMSService } from 'client/services';

const basicCMSPage = (titleI18nKey, service) => {
    const Page = () => <CMSPage title={titleI18nKey} />;
    const loader = async ({ params }) => {
        // Not all services use contentKey (only newsContent and helpContent at present)
        // but it does no harm to pass it through anyway, as other services will just ignore
        const content = await service(params.contentKey);
        return { content };
    };

    return [Page, loader];
};

const [ContactPageSignedOut, ContactPageSignedOutLoader] = basicCMSPage('cms.contactPageSignedOut.title', CMSService.getContactSignedOut);
const [ContactPage, ContactPageLoader] = basicCMSPage('cms.contactPage.title', CMSService.getContact);
const [CookiesPage, CookiesPageLoader] = basicCMSPage('cms.cookiesPage.title', CMSService.getCookiePolicy);
const [HelpPage, HelpPageLoader] = basicCMSPage('cms.helpPage.title', CMSService.getHelp);
const [HelpPageSignedOut, HelpPageSignedOutLoader] = basicCMSPage('cms.helpSignedOut.title', CMSService.getHelpSignedOut);
const [HelpContent, HelpContentLoader] = basicCMSPage('cms.helpContent.title', CMSService.getHelpContent);
const [HSG47Page, HSG47PageLoader] = basicCMSPage('cms.HSG47Page.title', CMSService.getHSG47);
const [NewsPage, NewsPageLoader] = basicCMSPage('cms.newsPage.title', CMSService.getNews);
const [NewsContent, NewsContentLoader] = basicCMSPage('cms.newsContent.title', CMSService.getNewsContent);
const [NoOrganisationsPage, NoOrganisationsPageLoader] = basicCMSPage('cms.noOrganisationsPage.title', CMSService.getNoOrganisations);
const [PrivacyPage, PrivacyPageLoader] = basicCMSPage('cms.privacyPage.title', CMSService.getPrivacyPolicy);
const [ReleaseNotes, ReleaseNotesLoader] = basicCMSPage('cms.releaseNotes.title', CMSService.getReleaseNotes);
const [WorkingOn, WorkingOnLoader] = basicCMSPage('cms.workingOn.title', CMSService.getWorkingOn);

export default CMSPage;

export {
    CMSPage,
    ContactPageSignedOut, ContactPageSignedOutLoader,
    ContactPage, ContactPageLoader,
    CookiesPage, CookiesPageLoader,
    HelpPage, HelpPageLoader,
    HelpPageSignedOut, HelpPageSignedOutLoader,
    HelpContent, HelpContentLoader,
    HSG47Page, HSG47PageLoader,
    NewsPage, NewsPageLoader,
    NewsContent, NewsContentLoader,
    NoOrganisationsPage, NoOrganisationsPageLoader,
    PrivacyPage, PrivacyPageLoader,
    ReleaseNotes, ReleaseNotesLoader,
    WorkingOn, WorkingOnLoader
};
